const domain = 'AsyncStatus';

export const START = `${domain}/START`;
export const SUCCESS = `${domain}/SUCCESS`;
export const ERROR = `${domain}/ERROR`;
export const INITIALIZE = `${domain}/INITIALIZE`;
export const CLEAR = `${domain}/CLEAR`;

export default domain;
